import type { ReactElement } from "react";
import { Link } from "react-router";
import type { PublicNavEntry } from "@/app/layout/public-navigation";

/**
 * One link of the public header or side menus: an in-app route, or an external destination that
 * opens in a new tab and says so to assistive technology.
 */
export function PublicNavLink({
  entry,
  current,
  className,
  onClick,
}: {
  entry: PublicNavEntry;
  current: boolean;
  className: string;
  onClick?: () => void;
}): ReactElement {
  if (entry.external) {
    return (
      <a
        href={entry.href}
        target="_blank"
        rel="noreferrer noopener"
        className={className}
        onClick={onClick}
      >
        {entry.label} <span className="sr-only">(opens in a new tab)</span>
      </a>
    );
  }
  return (
    <Link
      to={entry.href}
      aria-current={current ? "page" : undefined}
      className={className}
      onClick={onClick}
    >
      {entry.label}
    </Link>
  );
}
